import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Button, Table, Select} from 'antd'
import FormModalAddKey from './FormModalAddKey'
import FormModalRules from './FormModalRules'
import mappingManagementAPI from '../../../apis/mappingManagementAPI'
import {toJS} from 'mobx'
import rulesIcon01 from '../../../assets/images/rulesIcon01.png'
import rulesIcon02 from '../../../assets/images/rulesIcon02.png'
import CustomerMasterData from '../../customerMasterData'
import {EyeOutlined} from '@ant-design/icons'
import GroovyModal from './groovyModal'
import {withTranslation} from 'react-i18next'

@inject('mappingManagementStore')
@observer
class FormModalNext extends Component {
  state = {
    addKeyModalVisible: false, /*是否显示addKey窗口*/
    apiFilterModalVisible: false, /*是否显示api Filter窗口*/
    rulesModalVisible: false, /*是否显示rules窗口*/
    formualVisible: false, /*是否显示Formual列*/
    processingVisible: false, /*是否显示preProcessing和postProcessing下拉框*/
    rulesIndex: null, /* rules index*/
    recordDate: null,
    modalVisibleParameter: false,
    record: null,
    groovyList: [],
    preGroovyList: [],
    postGroovyList: [],
    preGroovyId: '',
    postGroovyId: '',
    preGroovyVisible: false,
    postGroovyVisible: false,
    groovyClient: null,
    groovyName: null,
    groovyScript: null
  }
  formRef = React.createRef()

  componentDidMount() {
    this.getGroovy()
    const {mappingManagementStore, title} = this.props
    const {mappingDetails} = mappingManagementStore
    if (mappingDetails?.mappingAttributeAlias === 'Base') {
      this.setState({
        formualVisible: true,
        processingVisible: true
      })
    }
    if (title === 'edit') {
      for (var i = 0; i < mappingDetails?.dataFieldMappings?.length; i++) {
        for (var j = 0; j < mappingDetails?.dataFieldMappings[i]?.dependFields?.length; j++) {
          this.formRef.current.setFieldsValue({
            [`rulesFieldListValue_${i + 1}_${j + 1}`]: mappingDetails?.dataFieldMappings[i]?.dependFields[j]?.path
          })
        }
      }
      this.formRef.current.setFieldsValue({
        preProcessing: mappingDetails?.preProcessing,
        postProcessing: mappingDetails?.postProcessing
      })
    }
    this.onGetFormulaInfosAction()
    // this.formRef.current.setFieldsValue({
    //   name: title==='edit'? mappingDetails.name:fieldsValue.name
    // })
  }

  onGetFormulaInfosAction = () => {
    const {mappingManagementStore} = this.props
    mappingManagementStore.onGetFormulaInfosAction()
  }
  /*Add Key*/
  handleCreateKey = () => {
    this.setState({
      addKeyModalVisible: true
    })
  }
  handleCancelKey = () => {
    this.setState({
      addKeyModalVisible: false
    })
  }
  /*rules*/
  handleCreateRules = (record, index, rulesType) => {
    this.setState({
      rulesModalVisible: true,
      rulesIndex: index,
      recordDate: record,
      rulesType: rulesType,
    })
  }
  handleCancelRules = () => {
    this.setState({
      rulesModalVisible: false,
      rulesIndex: null,
      recordDate: null,
      rulesType: null,
    })
  }
  handleOk = () => {
    const {mappingManagementStore, handleCancelNext, title} = this.props
    mappingManagementStore.encryptionAction()
    const {
      mappingDetails,
      filtersDataSourceEncryption,
      inboundTypeNameDetails,
      outboundTypeNameDetails,
      fieldDataSourceEncryption
    } = mappingManagementStore
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {}
      if (title === 'edit') {
        params = {
          'dataFieldMappings': JSON.parse(JSON.stringify(fieldDataSourceEncryption).replace(/\//g, '.')),
          // "dataVersion": mappingDetails.dataVersion,
          'fieldFilters': filtersDataSourceEncryption,
          // "preProcessing": preProcessingDataSource,
          'inboundConfigId': mappingDetails.inboundConfigInfo.id,
          'id': mappingDetails.id,
          'name': mappingDetails.name,
          'outboundConfigId': mappingDetails.outboundConfigInfo.id,
          // "statusType": mappingDetails.status
        }
        if (this.state.processingVisible) {
          params.preProcessing = fieldsValue.preProcessing
          params.postProcessing = fieldsValue.postProcessing
        }
      } else {
        params = {
          'dataFieldMappings': JSON.parse(JSON.stringify(fieldDataSourceEncryption).replace(/\//g, '.')),
          // "dataVersion": 0,
          'fieldFilters': filtersDataSourceEncryption,
          // "preProcessing": preProcessingDataSource,
          'inboundConfigId': inboundTypeNameDetails.id,
          'name': this.props.fieldsValue.name,
          'outboundConfigId': outboundTypeNameDetails.id,
          // "statusType": 'Freeze'
        }
        if (this.state.processingVisible) {
          params.preProcessing = fieldsValue.preProcessing
          params.postProcessing = fieldsValue.postProcessing
        }
      }
      // mappingManagementStore.onChangePageNo()
      mappingManagementStore.onSaveMappingAction(params).then(res => {
        if (res?.data?.code === 0) {
          handleCancelNext()
        }
      })
    }).catch(err => {})
  }
  onSelect = (selectedKeys, info) => {
  }
  getGroovy = () => {
    mappingManagementAPI.getGroovyAction('MAPPING').then(res => {
      this.setState({
        groovyList: res.data.data
      })
    })
    mappingManagementAPI.getGroovyAction('MAPPINGPRE').then(res => {
      this.setState({
        preGroovyList: res.data.data
      })
    })
    mappingManagementAPI.getGroovyAction('MAPPINGPOST').then(res => {
      this.setState({
        postGroovyList: res.data.data
      })
    })
  }
  onPreGroovyChange = (value) => {
    this.setState({
      preGroovyId: value
    })
  }
  onPostGroovyChange = (value) => {
    this.setState({
      postGroovyId: value
    })
  }

  handlePreGroovy = () => {
    this.setState({
      preGroovyId: this.formRef.current.getFieldValue('preProcessing')
    })
    if (this.formRef.current.getFieldValue('preProcessing')) {
      this.getGroovyDetail(this.formRef.current.getFieldValue('preProcessing'), 'preGroovyVisible')
    }
  }

  getGroovyDetail = (id, key) => {
    mappingManagementAPI.getGroovyDetailAction(id).then(res => {
      let resData = res.data.data
      this.setState({
        groovyClient: resData.client,
        groovyName: resData.name,
        groovyScript: resData.script,
        [key]: true
      })
    }).catch(err => {
      console.log(err)
    })
  }

  handlePreGroovyCancel = () => {
    this.setState({
      preGroovyVisible: false
    })
  }
  handlePostGroovy = () => {
    this.setState({
      postGroovyId: this.formRef.current.getFieldValue('postProcessing')
    })
    if (this.formRef.current.getFieldValue('postProcessing')) {
      this.getGroovyDetail(this.formRef.current.getFieldValue('postProcessing'), 'postGroovyVisible')
    }
  }
  handlePostGroovyCancel = () => {
    this.setState({
      postGroovyVisible: false
    })
  }
  handleAddRtmCascader = (index) => {
    const {mappingManagementStore} = this.props
    mappingManagementStore.onAddFieldDataSource(index)
  }
  handleDelRtmCascader = (index, ids) => {
    const {mappingManagementStore} = this.props
    const {fieldDataSource} = mappingManagementStore
    // $(`#rulesFieldLi_${index + 1}_${ids + 1}`).remove()
    mappingManagementStore.onDelFieldDataSource(index, ids)
    for (var i = 0; i < fieldDataSource.length; i++) {
      for (var j = 0; j < fieldDataSource[i].dependFields.length; j++) {
        this.formRef.current.setFieldsValue({
          [`rulesFieldListValue_${i + 1}_${j + 1}`]: fieldDataSource[i]?.dependFields[j]?.path
        })
      }
    }
  }

  handleParameter = (record) => {
    const {mappingManagementStore} = this.props
    const {mappingDetails} = mappingManagementStore
    this.setState({
      modalVisibleParameter: true,
      record: mappingDetails
    })
  }
  handleCancelParameter = () => {
    this.setState({
      modalVisibleParameter: false
    })
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  rowKey1 = (item) => {
    return item.path ? item.path : ''
  }
  rowKey = (item) => {
    return item.fieldInfo.path
  }

  render() {
    const {mappingManagementStore, nextModalVisible, handleCancelNext, title, fieldsValue, t} = this.props
    const {inboundListTree, mappingDetails, fieldDataSource} = mappingManagementStore
    return (
      <>
        <Modal
          title={title === 'edit' ? `${t(`general.edit`)} ${t(`mappingManagement.mapping`)}` : t(`mappingManagement.createNewMapping`)}
          visible={nextModalVisible}
          // onOk={this.handleOk}
          onCancel={handleCancelNext}
          maskClosable={false}
          destroyOnClose={true}
          width="90%"
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancelNext}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form key="FieldMappingForm" ref={this.formRef}>
            <Row style={{marginBottom: 10}}>
              <Col span={8} style={{lineHeight: '32px', paddingBottom: 10}}>
                <span style={{
                  fontSize: 14,
                  fontWeight: 500
                }}>{t(`mappingManagement.mappingName`)}: </span>{fieldsValue ? fieldsValue.name : mappingDetails.name}
                {/*<Form.Item name='name' label="Mapping Name" labelCol={{span:8}} wrapperCol={{span:16}}*/}
                {/*           rules={[{ required: true, message: 'Please enter Mapping Name without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>*/}
                {/*  <Input maxLength={100} placeholder="Please enter mapping name" allowClear />*/}
                {/*</Form.Item>*/}
              </Col>
              <Col span={10} xl={{span: 16}} xxl={{span: 10}}>
                {
                  this.state.processingVisible ? (
                    <>
                      <span style={{fontSize: 14, fontWeight: 500}}>{t(`mappingManagement.preProcessing`)}: </span>
                      <Form.Item name="preProcessing" noStyle>
                        <Select placeholder={t(`general.pleaseSelect`)} onChange={this.onPreGroovyChange} allowClear
                                style={{width: 180, textAlign: 'left'}}>
                          {this.state.preGroovyList.length > 0 ? this.state.preGroovyList.map(item => <Select.Option key={item.id}
                                                                                                                     value={item.id}>{item.name}</Select.Option>) : null}
                        </Select>
                      </Form.Item>
                      <Button style={{marginLeft: 5, marginRight: 5}} type="link" icon={<EyeOutlined/>} onClick={this.handlePreGroovy}
                              title={t(`general.display`)}/>
                      <span style={{fontSize: 14, fontWeight: 500}}>{t(`mappingManagement.postProcessing`)}: </span>
                      <Form.Item name="postProcessing" noStyle>
                        <Select placeholder={t(`general.pleaseSelect`)} onChange={this.onPostGroovyChange} allowClear
                                style={{width: 180, textAlign: 'left'}}>
                          {this.state.postGroovyList.length > 0 ? this.state.postGroovyList.map(item => <Select.Option key={item.id}
                                                                                                                       value={item.id}>{item.name}</Select.Option>) : null}
                        </Select>
                      </Form.Item>
                      <Button style={{marginLeft: 5, marginRight: 5}} type="link" icon={<EyeOutlined/>} onClick={this.handlePostGroovy}
                              title={t(`general.display`)}/>
                    </>
                  ) : null
                }
              </Col>
              <Col span={6} xl={{span: 6, offset: 18}} xxl={{span: 6, offset: 0}} style={{textAlign: 'right'}}>
                <Button style={{marginRight: 10}} onClick={() => this.handleParameter()} type="primary"
                        title="Parameter">{t(`mappingManagement.parameter`)}</Button>
                <Button style={{marginRight: 10}} onClick={this.handleCreateKey} type="primary">{t(`mappingManagement.addKey`)}</Button>
                {/*<Button style={{marginRight: 10, width:110}} onClick={() => this.handleCreateRules(mappingDetails,'',1)} type='primary'>Pre Process</Button>*/}
                <Button onClick={() => this.handleCreateRules(mappingDetails, '', 2)} type="primary">{t(`mappingManagement.filter`)}</Button>
              </Col>
            </Row>
            <Row>
              <Col span={8}><span style={{
                fontSize: 14,
                fontWeight: 500
              }}>{t(`mappingManagement.inboundCustomer`)}: </span> {fieldsValue ? fieldsValue.inboundCustomer : mappingDetails.inboundConfigInfo.customerStr}
              </Col>
              <Col span={8}><span style={{
                fontSize: 14,
                fontWeight: 500
              }}>{t(`mappingManagement.outboundCustomer`)}:</span> {fieldsValue ? fieldsValue.outboundCustomer : mappingDetails.outboundConfigInfo.customerStr}
              </Col>
            </Row>
            <Row>
              <Col span={8}><span style={{
                fontSize: 14,
                fontWeight: 500
              }}>{t(`mappingManagement.inboundName`)}: </span> {fieldsValue ? fieldsValue.inboundName : mappingDetails.inboundConfigInfo.apiName}
              </Col>
              <Col span={16}><span style={{
                fontSize: 14,
                fontWeight: 500
              }}>{t(`mappingManagement.outboundName`)}:</span> {fieldsValue ? fieldsValue.outboundName : mappingDetails.outboundConfigInfo.apiName}
              </Col>
            </Row>
            <Row className="mappingRow" style={{height: '400px', marginTop: 20}}>
              <Col span={8} className="mappingCol">
                {/*<Tree*/}
                {/*  onSelect={this.onSelect}*/}
                {/*  titleRender={(item)=>{ return item.name}}*/}
                {/*  treeData={inboundListTree}*/}
                {/*  style={{height: 390, overflowY: 'scroll'}}*/}
                {/*/>*/}
                <Table className="mappingTable" rowKey={this.rowKey1} rowClassName={this.getRowClassName} dataSource={toJS(inboundListTree)}
                       defaultExpandAllRows={true} pagination={false} scroll={{y: 353}} indentSize={30} style={{height: 400}}>
                  <Table.Column align="left" title={t(`mappingManagement.fieldName`)} dataIndex="name" key="name" ellipsis={true}/>
                  <Table.Column width={100} title={t(`mappingManagement.fieldType`)} dataIndex="fieldType" key="fieldType"/>
                </Table>
              </Col>
              <Col span={16} className="mappingCol">
                <Table className="mappingTable" pagination={false} rowClassName={this.getRowClassName} rowKey={this.rowKey} scroll={{y: 353}}
                       indentSize={30} style={{height: 400}}
                       dataSource={toJS(fieldDataSource)}
                >
                  <Table.Column align="left" title={t(`mappingManagement.fieldName`)} dataIndex="fieldInfo" key="fieldInfo" ellipsis={true}
                                render={(text, record, index) => record?.fieldInfo?.path}/>
                  <Table.Column width={150} title={t(`mappingManagement.type`)} dataIndex="fieldType" key="fieldType"
                                render={(text, record, index) => record?.fieldInfo?.fieldType}/>
                  {this.state.formualVisible ?
                    <Table.Column width={150} title={t(`mappingManagement.formula`)} dataIndex="formula" key="formula"
                                  render={(text, record, index) => <>
                                    <Button onClick={() => this.handleCreateRules(record.computationExpression, index, null)} type="link">
                                      <img alt="" src={record?.computationExpression === '' ? rulesIcon01 : rulesIcon02}
                                           style={{height: '100%', width: 'auto'}}/>
                                    </Button>
                                  </>}/> : null
                  }
                </Table>
              </Col>
            </Row>
          </Form>
        </Modal>
        {this.state.addKeyModalVisible ? <FormModalAddKey
          addKeyModalVisible={this.state.addKeyModalVisible}
          handleCancelKey={this.handleCancelKey}
          title={this.props.title}
        /> : null}
        {this.state.rulesModalVisible ? <FormModalRules
          addKeyModalVisible={this.state.rulesModalVisible}
          handleCancelRules={this.handleCancelRules}
          rulesIndex={this.state.rulesIndex}
          recordDate={this.state.recordDate}
          rulesType={this.state.rulesType}
        /> : null}

        {this.state.modalVisibleParameter ?
          <Modal
            title={[<p key={'title'} style={{marginBottom: 0}}>{t(`mappingManagement.mappingName`)}: <span
              style={{fontWeight: 'normal'}}>{this.state.record.name}</span>
            </p>]}
            // closable={false}
            onCancel={this.handleCancelParameter}
            visible={this.state.modalVisibleParameter}
            maskClosable={false}
            destroyOnClose={true}
            width="60%"
            centered
            footer={null}
          >
            <CustomerMasterData dataType="parameter" record={this.state.record}/>
          </Modal> : null}
        {this.state.preGroovyVisible ? <GroovyModal
          verVisible={this.state.preGroovyVisible}
          handleCancel={this.handlePreGroovyCancel}
          id={this.state.preGroovyId}
          state={this.state}
        /> : null}
        {this.state.postGroovyVisible ? <GroovyModal
          verVisible={this.state.postGroovyVisible}
          handleCancel={this.handlePostGroovyCancel}
          id={this.state.postGroovyId}
          state={this.state}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(FormModalNext)
